var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSort(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Outline / Essentional, UI / Sort"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.1665 4.66602C15.1665 4.94216 14.9426 5.16602 14.6665 5.16602L1.33317 5.16602C1.05703 5.16602 0.83317 4.94216 0.83317 4.66602C0.83317 4.38987 1.05703 4.16602 1.33317 4.16602L14.6665 4.16602C14.9426 4.16602 15.1665 4.38987 15.1665 4.66602Z",
    fill: "#1A1B1D"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.1665 8C13.1665 8.27614 12.9426 8.5 12.6665 8.5L3.33317 8.5C3.05703 8.5 2.83317 8.27614 2.83317 8C2.83317 7.72386 3.05703 7.5 3.33317 7.5L12.6665 7.5C12.9426 7.5 13.1665 7.72386 13.1665 8Z",
    fill: "#1A1B1D"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.1665 11.334C11.1665 11.6101 10.9426 11.834 10.6665 11.834H5.33317C5.05703 11.834 4.83317 11.6101 4.83317 11.334C4.83317 11.0578 5.05703 10.834 5.33317 10.834H10.6665C10.9426 10.834 11.1665 11.0578 11.1665 11.334Z",
    fill: "#1A1B1D"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSort);
export default __webpack_public_path__ + "static/media/Sort.49368b3b512c52d867f410ff17ca2411.svg";
export { ForwardRef as ReactComponent };